<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Stream History</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by ShortCode</u></label>
        <ng-select [items]="shortCodeFilterList" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for="">Filter by Keyword</label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword" (ngModelChange)="changeKeyword($event)">
          <option value=null selected>All</option>
          <option *ngFor="let keyword of keywordList | keyvalue" [ngValue]="keyword">{{keyword.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for="">Filter by Operator</label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
          <option value="" selected>All</option>
          <option *ngFor="let operator of operatorList" [ngValue]="operator">{{operator}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Postback State</u></label>
        <select [(ngModel)]="filterable.panOutState" class="form-control" placeholder="">
          <option value="" selected>-select state-</option>
          <option *ngFor="let pan of panOutStateList | keyvalue" [value]="pan.key">{{pan.value}}</option>
        </select>
      </div>
      <div class="col text-right align-self-end">
          <button class="btn btn-danger btn-sm mr-2" (click)="onClear()">Clear</button>
          <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
          <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
          <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
          <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="moList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>Transaction Time</th>
      <th>MsgID</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>ReceiveRequestString</th>
      <th>Postback<br>(State,Time,URL,Result)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="12">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="12">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let stream of streamList; index as i;">
      <td nowrap class="text-left">{{stream.transactionAtView}}<br>{{stream.createdAtView}}</td>
      <td nowrap>{{stream.msgId}}</td>
      <td>{{stream.shortCode}}</td>
      <td>{{stream.keyword}}</td>
      <td>{{stream.operator}}</td>
      <td class="text-left">{{stream.uriVariables}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">State:</span>{{stream.panOutStateView}}<br>
        <span class="font-italic font-weight-bold">DryState:</span>{{stream.dryPanOutStateView}}<br>
        <span class="font-italic font-weight-bold">At:</span>{{stream.panOutAtView}}<br>
        <span class="font-italic font-weight-bold">URL:</span>{{stream.panOutUrl}}<br>
        <span class="font-italic font-weight-bold">Result:</span>{{stream.panOutMsg}}
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="12" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
